module.exports = __webpack_public_path__ + "static/media/img5.a170d900.png";